import {
  Collection,
  CollectionItem,
  CollectionResponse,
  FullItems,
  Video,
} from "@/api";
import { useCollection } from "@/hooks";
import { Slider } from "@/components";
import { useMemo } from "react";
import { ITEM_TYPE_COLLECTION, ITEM_TYPE_VIDEO } from "@/const.ts";

interface PageOfSlidersProps {
  collectionId: number;
}

/**
 *  This page is for when you have a CollectionDetails screen that renders a list of sliders
 *  See also "ContentTab.tsx" for main tabs that display sliders
 * @param collectionId - The collection being displayed, that contains a list of collections
 */
export const PageOfSliders = ({ collectionId }: PageOfSlidersProps) => {
  const { data } = useCollection(collectionId);

  return (
    <div>
      {data?.Items.map((i) => {
        return <SliderContainer item={i} data={data} key={i.ChildId} />;
      })}
    </div>
  );
};

const SliderContainer = ({
  item,
  data,
}: {
  item: CollectionItem;
  data: CollectionResponse;
}) => {
  const collection = useMemo(() => {
    return data?.ChildCollections[parseInt(item.ChildId)];
  }, [data?.ChildCollections, item.ChildId]);

  // Find a full copy of each Collection and Video to be displayed
  const fullItems = useMemo(() => {
    const { ChildVideos, ChildCollections } = data ?? {};
    if (!ChildVideos || !ChildCollections) {
      return {} as FullItems;
    }

    const videos: Record<number, Video> = {};
    const collections: Record<number, Collection> = {};
    for (const i of collection?.Items ?? []) {
      const itemId = parseInt(i.ChildId);
      if (i.Type == ITEM_TYPE_VIDEO) {
        const video = ChildVideos[parseInt(i.ChildId)];
        if (video) {
          videos[itemId] = video;
        }
      }
      if (i.Type == ITEM_TYPE_COLLECTION) {
        const col = ChildCollections[parseInt(i.ChildId)];
        if (col) {
          collections[itemId] = col;
        }
      }
    }
    return { videos, collections };
  }, [data, collection?.Items]);

  if (!collection || collection.Items.length === 0) {
    return null;
  }

  return (
    <div className="pb-[40px] ">
      <Slider collection={collection} fullItems={fullItems} />
    </div>
  );
};
